<mat-card>
  <mat-card-header>
    <mat-card-title>
      Privatlån administration
    </mat-card-title>
    <mat-card-subtitle>
      Listan nedan är alla <em>aktiva</em> privatlåneansökningar.
    </mat-card-subtitle>
  </mat-card-header>
  <mat-card-content>
    <div class="table">

      <table [dataSource]="items" mat-table matSort>
        <caption>List of Blanco loans</caption>
        <ng-container matColumnDef="date">
          <th *matHeaderCellDef id="date" mat-header-cell mat-sort-header>
            Datum
          </th>
          <td
            *matCellDef="let element"
            [routerLink]="['/admin/blanco', element.id]"
            class="clickable" mat-cell> {{ element.date }}
          </td>
        </ng-container>

        <ng-container matColumnDef="time">
          <th *matHeaderCellDef id="time" mat-header-cell mat-sort-header>
            Klockslag
          </th>
          <td
            *matCellDef="let element"
            [routerLink]="['/admin/blanco', element.id]"
            class="clickable" mat-cell> {{ element.time }}
          </td>
        </ng-container>

        <ng-container matColumnDef="applicant">
          <th *matHeaderCellDef id="name" mat-header-cell
              mat-sort-header>Sökande
          </th>
          <td
            *matCellDef="let element"
            [routerLink]="['/admin/blanco', element.id]"
            class="clickable" mat-cell> {{ element.applicant }}
          </td>
        </ng-container>

        <ng-container matColumnDef="coApplicant">
          <th *matHeaderCellDef id="coApplicant" mat-header-cell
              mat-sort-header>Medsökande
          </th>
          <td
            *matCellDef="let element"
            [routerLink]="['/admin/blanco', element.id]"
            class="clickable" mat-cell> {{ element.coApplicant }}
          </td>
        </ng-container>

        <ng-container matColumnDef="granted">
          <th *matHeaderCellDef id="granted" mat-header-cell>Status</th>
          <td
            *matCellDef="let element"
            mat-cell>
            <spb-indicator [codeList]="element.codes"/>
          </td>
        </ng-container>

        <ng-container matColumnDef="amount">
          <th *matHeaderCellDef id="sum" mat-header-cell mat-sort-header>
            Summa
          </th>
          <td
            *matCellDef="let element"
            [routerLink]="['/admin/blanco', element.id]"
            class="clickable" mat-cell> {{ element.amount }}
          </td>
        </ng-container>

        <ng-container matColumnDef="delegate">
          <th *matHeaderCellDef id="delegate" mat-header-cell
              mat-sort-header>Ansvarig
          </th>
          <td *matCellDef="let element" mat-cell>
            <div class="table-button">
              <button (click)="delegate(element.application)" matButton="outlined">
                {{ element.delegate || 'Tilldela' }}
              </button>
            </div>
          </td>
        </ng-container>


        <tr *matHeaderRowDef="columns()" mat-header-row></tr>
        <tr *matRowDef="let element; columns: columns()" mat-row>

        <tr *matNoDataRow>
          <td [attr.colspan]="columns().length">
            <span>Hämtar ansökningar...</span>
          </td>
        </tr>
      </table>
    </div>

    <mat-paginator [pageSizeOptions]="[10, 50, 100]"
                   [pageSize]="10" showFirstLastButtons/>

  </mat-card-content>
</mat-card>

